// extracted by mini-css-extract-plugin
export default {"BrowerSuggestionTip-wrap":"BrowerSuggestionTip_BrowerSuggestionTip-wrap__SfXZf","title":"BrowerSuggestionTip_title__o93fY"};